import { FC, useCallback, PropsWithChildren } from "react";
import { ChatServerButton, ChatServerListItem, getItemUrl } from "../../xapp/ChatServerMessage";
import { OptionalLink } from "../OptionalLink";
import "./ActionItem.scss";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";

export interface ActionItemProps {
    readonly className?: string;
    readonly item: ChatServerListItem;
    onButtonClick(button: ChatServerButton): void;
    onExecute(text: string, token?: string): void;
    onOpenUrl: OpenUrlCallback;
}

export const ActionItem: FC<PropsWithChildren<ActionItemProps>> = (props) => {
    const { item, onButtonClick, onExecute } = props;

    const singleButton = item.buttons?.length === 1;

    const handleClick = useCallback(() => {
        const btns = item.buttons?.length;
        // If there is only one button, it takes precedent
        // and the whole thing is the button
        if (btns === 1) {
            onButtonClick(item.buttons[0]);
        } else {
            onExecute(item.title, item.token);
        }
    }, [item, onExecute, onButtonClick]);

    const className = `xappw-chat-action-item ${
        singleButton ? "xappw-chat-action-item--action" : ""
    } ${props.className}`;

    return (
        <OptionalLink
            className={className}
            url={getItemUrl(item)}
            onClick={handleClick}
            onOpen={props.onOpenUrl}>
            {props.children}
        </OptionalLink>
    );
};
